import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Check, HelpCircle } from "lucide-react";
import { api } from "@/lib/api";
import { LANE_ICONS } from "@/pages/HomePage";

const fmtK = (n) => (n >= 1000 ? `$${Math.round(n / 1000)}K` : `$${n}`);

export default function ServicesPage() {
  const [lanes, setLanes] = useState([]);
  useEffect(() => { api.get("/lanes").then((r) => setLanes(r.data.lanes)).catch(() => {}); }, []);
  return (
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 md:py-20" data-testid="services-page">
      <span className="eyebrow">Services · Six Lanes</span>
      <h1 className="mt-2 font-display text-4xl uppercase text-chrome sm:text-5xl lg:text-6xl">What EON <span className="text-gold">Produces.</span></h1>
      <p className="mt-4 max-w-2xl text-neutral-300">Every lane has a transparent starting price, a defined deliverable list and the four things we need from you to quote it. No mystery pricing.</p>
      <div className="mt-12 space-y-6">
        {lanes.map((l, i) => {
          const Icon = LANE_ICONS[l.id];
          return (
            <motion.div key={l.id} id={l.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              className="glass grid gap-6 rounded-3xl p-6 md:grid-cols-12 md:p-8" data-testid={`service-lane-${l.id}`}>
              <div className="md:col-span-4">
                <div className="flex items-center gap-3"><Icon className="h-7 w-7 text-cyan-400" /><span className="font-mono-label text-[10px] uppercase tracking-widest text-neutral-400">{l.tag}</span></div>
                <h2 className="mt-3 font-cond text-3xl font-extrabold uppercase leading-tight text-white">{l.name}</h2>
                <div className="mt-3 font-display text-3xl text-gold">from {fmtK(l.starting)}</div>
                <div className="font-mono-label text-[10px] uppercase tracking-widest text-neutral-500">{l.unit}</div>
                <p className="mt-4 text-sm text-neutral-400">{l.pitch}</p>
              </div>
              <div className="md:col-span-4">
                <h4 className="font-mono-label text-[10px] uppercase tracking-widest text-cyan-500">Deliverables</h4>
                <ul className="mt-3 space-y-2">{l.deliverables.map((d) => <li key={d} className="flex gap-2 text-sm text-neutral-300"><Check className="mt-0.5 h-4 w-4 shrink-0 text-cyan-500" />{d}</li>)}</ul>
              </div>
              <div className="flex flex-col md:col-span-4">
                <h4 className="font-mono-label text-[10px] uppercase tracking-widest text-cyan-500">What we need from you</h4>
                <ul className="mt-3 flex-1 space-y-2">{l.needs.map((d) => <li key={d} className="flex gap-2 text-sm text-neutral-300"><HelpCircle className="mt-0.5 h-4 w-4 shrink-0 text-neutral-500" />{d}</li>)}</ul>
                <Link to={l.link || `/request?lane=${l.id}`} data-testid={`service-cta-${l.id}`} className="btn-gold mt-6 flex items-center justify-center gap-2 rounded-full py-3 font-cond font-bold uppercase">
                  {l.link ? "Open" : "Request a Quote"} <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
